module.exports = __webpack_public_path__ + "img/selected6-min.7e0d8836.png";